import React from 'react'

const Title: React.FC<{ text: string }> = ({ text }) => (
  <div className="font-weight-bold text-center" style={{ marginBottom: '8px' }}>
    {text}
  </div>
)

export default Title
